export default __webpack_public_path__ + "static/media/Profile-Picture.de04d368.svg";